import { Component } from '@angular/core';

@Component({
  selector: 'app-supplementary-parcel-purchase-portal',
  templateUrl: './supplementary-parcel-purchase-portal.component.html',
  styleUrls: ['./supplementary-parcel-purchase-portal.component.scss'],
  standalone: false,
})
export class SupplementaryParcelPurchasePortalComponent {}
